import EmptyList from '@anm/components/EmptyList';
import { FC } from 'react';

import StreamItemWrapper from '../../../stream/SteamItemWrapper';
import Loader from '../Loader';
import Pagination from '../Pagination';
import { SectionWrapper } from '../Wrapper';
import { getEmptyListProps } from '../helpers';
import { useInProgressStreams } from '../hooks/useStreamsList';

const InProgressTab: FC = () => {
  const [isPending, list, isError] = useInProgressStreams();

  if (isPending) return <Loader />;

  const emptyListProps = getEmptyListProps({
    isError,
    iconSrc: 'images/icons/lps/mic_emoji.png',
    description: 'The moment you start your broadcast<br>it will be listed here'
  });

  if (isError || !list?.length) {
    return <EmptyList {...emptyListProps} />;
  }

  return (
    <SectionWrapper>
      {list?.map(item => (
        <StreamItemWrapper key={item.streamId} {...item} />
      ))}
      <Pagination />
    </SectionWrapper>
  );
};

export default InProgressTab;
